<template>
  <div class="less-negative">
    <lottie-player v-if="animate" class="image" :src="JSON.stringify(require('@/assets/celebration/lessnegative.json'))"
                   :autoplay="true" :loop="true"/>
    <img v-else class="image" :src="require('@/assets/celebration/lessnegative.svg')">
    <div class="well-done">
      <span>שיפור של</span>
      <span>{{ formatAmountWithFractionAndCurrency(amount) }}</span>
    </div>
    <div class="celebration-subtitle">
      <span>{{ householdName }},</span>
      <span>אמנם</span>
      <span>{{ thisMonth }}</span>
      <span>הסתיים בתזרים שלילי אבל החדשות הטובות הן שהוא נגמר טוב יותר מהחודש הקודם!</span>
    </div>
  </div>
</template>

<script>

import cashflowHistory from '@/store/utilities/cashflow-history';
import TransactionDisplayUtils
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/TransactionDisplayUtils';

export default {
  name: 'LessNegativeCore',
  mixins: [TransactionDisplayUtils],
  props: {
    amount: {
      type: Number,
      required: true,
    },
    cashflowDate: {
      type: String,
      required: true,
    },
    householdName: {
      type: String,
      required: true,
    },
    animate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    thisMonth() {
      return cashflowHistory.getFullMonthName(this.cashflowDate);
    },
  },
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.less-negative {
  text-align: center;
  font-family: SimplerProBold;

  .image {
    height: 100px;
  }

  .well-done {
    margin-bottom: 20px;
    margin-top: 35px;
    font-size: 24px;
    line-height: 20px;
  }

  .celebration-subtitle {
    font-family: SimplerPro;
    font-size: 18px;
    line-height: 25px;
  }
}

</style>
